import { render, staticRenderFns } from "./SubpageNavigation.vue?vue&type=template&id=19869fda&scoped=true&"
import script from "./SubpageNavigation.vue?vue&type=script&lang=js&"
export * from "./SubpageNavigation.vue?vue&type=script&lang=js&"
import style0 from "./SubpageNavigation.vue?vue&type=style&index=0&id=19869fda&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19869fda",
  null
  
)

export default component.exports